import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AfterLoginGuard} from './guards/after-login.guard';
import {NotAllowedComponent} from "./shared/components/not-allowed/not-allowed.component";
import {LoginComponent} from "./guest/login/login.component";
import {PageComponent} from "./page/page.component";
import {ForgotPasswordComponent} from "./guest/forgot-password/forgot-password.component";
import {CheckYourEmailComponent} from "./guest/check-your-email/check-your-email.component";
import {ResetPasswordComponent} from "./guest/reset-password/reset-password.component";
import {SetPasswordComponent} from "./guest/set-password/set-password.component";
import {ChangePasswordComponent} from "./guest/change-password/change-password.component";
import {GuestMainPageComponent} from "./guest/guest-page/guest-main-page/guest-main-page.component";
import {PortalGuard} from "./guards/portal.guard";
import {StaffGuard} from "./guards/staff.guard";
import {BeforeLoginGuard} from "./guards/before-login.guard";
import {ModuleLandingComponent} from "./shared/components/module-landing/module-landing.component";
import {UserProfileComponent} from "./guest/user-profile/user-profile.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'not-allowed',
    component: NotAllowedComponent,
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'manage',
    component: PageComponent,
    children: [
      {
        path: 'program-management',
        loadChildren: () =>
          import('./modules/program-management/program-management.module').then(
            (m) => m.ProgramManagementModule
          ),
        canActivate: [AfterLoginGuard, StaffGuard],
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('./modules/user-management/user-management.module').then(
            (m) => m.UserManagementModule
          ),
        canActivate: [AfterLoginGuard, StaffGuard],
      },
      {
        path: 'system-configuration',
        loadChildren: () =>
          import(
            './modules/system-configuration/system-configuration.module'
            ).then((m) => m.SystemConfigurationModule),
        canActivate: [AfterLoginGuard, StaffGuard],
      },
      {
        path: 'implementor',
        loadChildren: () =>
          import(
            './modules/implementor/implementor.module'
            ).then((m) => m.ImplementorModule),
        canActivate: [AfterLoginGuard, PortalGuard],
      },
      {
        path: 'implementor-settings',
        loadChildren: () =>
          import(
            './modules/implementor-settings/implementor-settings.module'
            ).then((m) => m.ImplementorSettingsModule),
        canActivate: [AfterLoginGuard, PortalGuard],
      },
      {
        path: 'mne',
        loadChildren: () =>
          import(
            './modules/monitoring-and-evaluation/monitoring-and-evaluation.module'
            ).then((m) => m.MonitoringAndEvaluationModule),
        canActivate: [AfterLoginGuard, StaffGuard],
      },
      {
        path: 'implementor-recommendation',
        loadChildren: () =>
          import(
            './modules/implementor-mne/implementor-mne.module'
            ).then((m) => m.ImplementorMneModule),
        canActivate: [AfterLoginGuard, PortalGuard],
      },
    ],
  },
  {
    path: 'portal',
    loadChildren: () =>
      import('./modules/portal/portal.module').then(
        (m) => m.PortalModule
      ),
  },

  {
    path: 'landing',
    component: ModuleLandingComponent,
    canActivate: [AfterLoginGuard],
  },

  {
    path: 'landing/profile',
    component: UserProfileComponent,
    canActivate: [AfterLoginGuard],
  },

  {
    path: 'home',
    component: GuestMainPageComponent,
    canActivate: [BeforeLoginGuard],
  },

  {
    path: 'login',
    component: LoginComponent,
    canActivate: [BeforeLoginGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'check-your-email',
    component: CheckYourEmailComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'activate-account/:token',
    component: SetPasswordComponent,
  },
  {path: '**', component: NotAllowedComponent},
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {anchorScrolling: 'enabled'}
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
